<template>
  <page-tabs
      ref="pageTabs"
      :tabs="[
        {icon:'mdi-phone-log', label:'Журнал звонков', name:'callGroups', path:'/contactCenter/callGroup/', perm:'contactCenterCall'},
        {icon:'mdi-phone-missed', label:'Задачи по звонкам', name:'callTasks', path:'/contactCenter/callTask/', perm:'contactCenterCallTask'},
        {icon:'mdi-message-text-outline', label:'Чаты', name:'chat', path:'/contactCenter/chat/', perm:'contactCenterChat'},
        {icon:'mdi-message-text-fast-outline', label:'Рассылка', name:'distribute', path:'/contactCenter/distribute/', perm:'contactCenterDistribute'},
        {icon:'mdi-message-text-outline', label:'Чаты (тестирование)', name:'dialogPage', path:'/contactCenter/dialog/', perm:'contactCenterChat'},
        {icon:'mdi-forum-outline', label:'Реестр чатов', name:'dialogChats', path:'/contactCenter/dialogChats/', perm:'contactCenterChat'},
    ]"
  >
    <template v-slot:default="{tabSelected}">
      <call-groups v-if="tabSelected==='callGroups'"
                   ref="callGroups"
                   :filter.sync="filter"
                   :callTargets="callTargets"
                   :callResults="callResults"
                   :callDirections="callDirections"
                   :statuses="statuses"
      />
      <call-tasks v-if="tabSelected==='callTasks'"
                  :filter.sync="filter"
                  :callTargets="callTargets"
                  :callResults="callResults"
                  :callDirections="callDirections"
                  :statuses="statuses"
      />
      <dialog-chats v-if="tabSelected==='dialogChats'"
                    :callTargets="callTargets"
                    :callResults="callResults"
      />
      <chat-clients v-if="tabSelected==='chat'" />
      <distribute v-if="tabSelected==='distribute'" />
      <dialog-page v-if="tabSelected==='dialogPage'" />
    </template>
  </page-tabs>
</template>

<script>
import moment from "moment";
import {Entity_CallResult, Entity_CallTarget} from "../../../EntityStoreCacheService";
import CallGroups from "@/views/ContactCenter/Call/CallGroups.vue";
import CallTasks from "@/views/ContactCenter/Call/CallTasks.vue";
import PageTabs from "@/componentsV2/base/PageTabs.vue";
import ChatClients from "@/views/ContactCenter/Messenger/ChatClients.vue";
import Distribute from "@/views/ContactCenter/Messenger/Distribute/Distribute.vue";
import DialogPage from "./Dialog/DialogPage.vue";
import DialogChats from "./Dialog/DialogChats.vue";

export default {
  components: {DialogChats, DialogPage, Distribute, PageTabs, CallTasks, CallGroups, ChatClients},
  data:()=>({
    filter: {
      dateFrom:moment().format('DD.MM.YYYY'),
      dateTo:moment().format('DD.MM.YYYY'),
      callDirections: [],
      statuses: [],
      phone: null,
      callTarget: null,
      callResult: null,
      userClientState: [],
      users: [],
      admins: []
    },
    callTargets:[],
    callResults:[],
    callDirections:[
      {name:'Внутренний',id:0,icon:'mdi-phone-incoming-outgoing'},
      {name:'Входящий',id:1, icon: 'mdi-phone-incoming'},
      {name:'Исходящий',id:2, icon: 'mdi-phone-outgoing'},
    ],
    statuses: [
      {name:'В процессе',id:'progress', color:'#428eda'},
      {name:'Успешно',id:'success', color:'#02924d'},
      {name:'Не отвечено',id:'fail', color:'#F44336'},
      {name:'Не отвечено в нерабочее время',id:'failNonWork', color:'#607D8B'},
    ],
  }),
  watch:{
    $route(){
      this.$nextTick(()=>{
        if(typeof this.$refs.callGroups!=='undefined')
          this.$refs.callGroups.externalTrigger();
      })
    }
  },
  mounted() {
    if(typeof this.$refs.callGroups!=='undefined')
      this.$refs.callGroups.externalTrigger();

    new Entity_CallTarget()
        .selects(Entity_CallTarget.id)
        .selects(Entity_CallTarget.name)
        .selects(Entity_CallTarget.comment)
        .selects([Entity_CallTarget.callResults, Entity_CallResult.id].join('.'))
        .selects([Entity_CallTarget.callResults, Entity_CallResult.name].join('.'))
        .selects([Entity_CallTarget.callResults, Entity_CallResult.type].join('.'))
        .selects([Entity_CallTarget.callResults, Entity_CallResult.comment].join('.'))
        .order(Entity_CallTarget.sort, true)
        .order([Entity_CallTarget.callResults, Entity_CallResult.sort].join('.'), true)
        .page(1)
        .onPage(1000)
        .addStateCallback((v)=>{
          if(v.success) this.callTargets = v.items;

          console.log('this.callTargets',this.callTargets);
        })
        .request()
    new Entity_CallResult()
        .selects(Entity_CallResult.id)
        .selects(Entity_CallResult.name)
        .selects(Entity_CallResult.type)
        .selects(Entity_CallResult.comment)
        .selects([Entity_CallResult.callTargets, Entity_CallTarget.id].join('.'))
        .order(Entity_CallResult.type, true)
        .order(Entity_CallResult.sort, true)
        .page(1)
        .onPage(1000)
        .addStateCallback((v)=>{
          if(v.success) this.callResults = v.items;
        })
        .request()
  },
}
</script>